// @flow

import React from 'react';
import uuid from 'uuid';
import { Divider, Form } from 'semantic-ui-react';
import type { PluginProps } from '../QuestionContent';

type Choice = {
  id: string,
  value: number,
  label: string,
};

const generateRatingChoices = (
  count: number,
  existing: Array<Choice>
): Array<Choice> => {
  return Array(count)
    .fill()
    .map((_, index) => {
      const existingChoice = existing[index];
      if (existingChoice != null) {
        return existingChoice;
      } else {
        return {
          id: uuid(),
          value: index + 1,
          label: '',
        };
      }
    });
};

const updateChoices = (
  choices: Array<Choice>,
  choice: Choice
): Array<Choice> => {
  return choices.map(item => {
    if (item.id !== choice.id) {
      return item;
    } else {
      return {
        ...item,
        ...choice,
      };
    }
  });
};

const isContentValid = content => {
  return (
    content.choices != null && content.choices.every(c => c.label.length > 0)
  );
};

const RatingContent = ({
  content,
  showValidationErrors,
  onChange,
}: PluginProps) => {
  const choices = content.choices || [];

  const change = content =>
    onChange({
      ...content,
      isValid: isContentValid(content),
      hasChanged: true,
    });

  const changeMax = (_, { value }) => {
    const valueAsNumber = Number(value);

    onChange({
      ...content,
      maxRating: valueAsNumber,
      choices: generateRatingChoices(valueAsNumber, choices),
    });
  };

  const updateChoice = (choice: Choice) =>
    change({
      ...content,
      choices: updateChoices(choices, choice),
    });

  return (
    <div>
      <Divider />
      <Form.Group inline>
        <label>Note maximum</label>
        <Form.Radio
          label="3/3"
          value="3"
          checked={content.maxRating === 3}
          onChange={changeMax}
        />
        <Form.Radio
          label="5/5"
          value="5"
          checked={content.maxRating === 5}
          onChange={changeMax}
        />
      </Form.Group>
      <RatingChoices
        choices={choices}
        showValidationErrors={showValidationErrors}
        onChangeChoice={updateChoice}
      />
      <Divider />
    </div>
  );
};

type ChoicesProps = {
  choices: Array<Choice>,
  showValidationErrors: boolean,
  onChangeChoice: (choice: Choice) => void,
};

const RatingChoices = ({
  choices,
  showValidationErrors,
  onChangeChoice,
}: ChoicesProps) => {
  if (choices.length > 0) {
    return (
      <Form.Group widths="equal">
        {choices.map(choice => (
          <RatingChoice
            key={choice.id}
            choice={choice}
            showValidationErrors={showValidationErrors}
            onChange={onChangeChoice}
          />
        ))}
      </Form.Group>
    );
  } else {
    return null;
  }
};

const RatingChoice = ({ choice, showValidationErrors, onChange }) => {
  const changeLabel = event =>
    onChange({
      ...choice,
      label: event.target.value,
    });

  return (
    <Form.Field
      required
      error={showValidationErrors && choice.label.length === 0}
    >
      <label>Libellé associé à la note {choice.value}</label>
      <input
        type="text"
        placeholder="Saisissez le libellé"
        value={choice.label}
        onChange={changeLabel}
      />
    </Form.Field>
  );
};

export default RatingContent;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/contents/RatingContent.js